const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDg1LjMzMyA1MTIgMzQxLjMzMyI+CjxnPgoJPHJlY3QgeT0iODUuMzM3IiBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjM0MS4zMjYiLz4KCTxyZWN0IHk9Ijg1LjMzNyIgZmlsbD0iI0ZGRkZGRiIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxNzAuNjYzIi8+CjwvZz4KPHJlY3QgeT0iMjU2IiBmaWxsPSIjRDgwMDI3IiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjE3MC42NjMiLz4KPC9zdmc+Cg==";
export {
  I as default
};
//# sourceMappingURL=PL-2ee94113.mjs.map
